import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '../generic/service/http.service';
import { Logger } from '../generic/logging/default-log.service';
import { BaseService } from '../generic/service/base.service';
import { ConfigurationHelper } from '../generic/helper/configuration.helper';
import { BlogResults } from '../components/blog/blog.results';
import { Blog } from '../components/blog/blog';

/**
 * Responsible for providing blogs and fetching them from the backend
 *
 * @author evandongen
 */
@Injectable()
export class BlogService extends BaseService {
    private http = inject(HttpClient);

    private blogRestUrl = '/rest/blogs';

    private blogGrowerRestUrl = this.blogRestUrl + '/grower';

    private blogRestDetailUrl = this.blogRestUrl + '/detail';

    constructor() {
        const logger = inject(Logger);

        super(logger);
    }

    /**
     * Get a list of Blog items
     */
    public getBlogs(pageNumber: number): Promise<BlogResults> {
        return lastValueFrom(
            this.http.get<BlogResults>(`${this.blogRestUrl}?page=${pageNumber}`),
        );
    }

    /**
     * Get the blog information for the given growerId
     * @param growerId
     */
    public getBlogForGrower(growerId: string): Promise<Blog> {
        return lastValueFrom(
            this.http.get<Blog>(`${this.blogGrowerRestUrl}?growerId=${growerId}`),
        );
    }

    /**
     * Get the detail page for the given blogId
     * @param blogId
     */
    public getBlogDetail(blogId: string): Promise<string> {
        return lastValueFrom(
            this.http.getText(
                ConfigurationHelper.getWebshopUrl(
                    `${this.blogRestDetailUrl}?blogId=${blogId}`,
                ),
            )
        );
    }
}
